<wk-icon-filled-close-sprite-pds3 />
<wk-icon-pencil-sprite-pds3 />
<wk-icon-trash-sprite-pds3 />
<wk-icon-save-sprite-pds3 />
<wk-icon-calendar-sprite-pds3 />
<wk-icon-close-circle-sprite-pds3 />
<wk-icon-filled-caution-sprite-pds3 />
<wk-icon-chevron-left-sprite-pds3 />
<wk-icon-chevron-right-sprite-pds3 />

@if (filtersService?.activeFilters?.size > 0 && !isFavoriteFilterEditMode) {
    <button-field-pds3 type="text" flowClass="custom-wk-clear-button">
        <button type="button" class="navbar_clearFilters" (click)="clearAllFilters()">
            <icon-pds3 name="wk-icon-filled-close"></icon-pds3>
            <span>{{ "FiltersSidebar.Labels.ClearAllFilters" | translate }}</span>
        </button>
    </button-field-pds3>
}
<wk-search />
<button
    kendoButton
    (click)="open()"
    [class.wk-fm__funnel--filled]="filtersService?.activeFilters?.size > 0"
    class="wk-fm__navbar-filter wk-fm__funnel"
></button>
<side-modal-pds3 cg3-theme="PDS-v3" (userRequest)="close($event)" [isOpen]="this.isOpen">
    <vertical-layout-pds3 flowClass="vertical-layout">
        <vertical-layout-header-pds3>
            <h5 class="wk-fm__sidebar-filter-header">
                <span class="wk-fm__sidebar-filter-title"> {{ "FiltersSidebar.Title" | translate }}</span>
                <div (click)="open()" flow-id="close-button" class="wk-fm__sidebar-filter-header close-button">
                    <icon-pds3 name="wk-icon-close"> </icon-pds3>
                </div>
            </h5>
        </vertical-layout-header-pds3>
        <vertical-layout-content-pds3 flowClass="vertical-layout-content">
            <accordion-pds3>
                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_Favorites']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_Favorites')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>
                        {{ "FiltersSidebar.Labels.MyFilters" | translate }}
                    </accordion-item-header-pds3>
                    <div class="favorites-filters-suggestions" *accordionItemBodyPds3>
                        @for (model of favoritesFilters; let idx = $index; track $index) {
                            <pill-suggestion-field-pds3 size="small" [isSelected]="model?.active">
                                <button type="button" (click)="toggleFavorite(model)" [attr.aria-selected]="model?.active">
                                    {{ model.id === "assigned-to-me" ? ("FiltersSidebar.Labels.AssignedToMe" | translate) : model.name }}
                                </button>
                            </pill-suggestion-field-pds3>
                        }
                    </div>
                </accordion-item-pds3>

                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_Active']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_Active')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{
                        "FiltersSidebar.Labels.ActiveFilters" | translate
                    }}</accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (filtersService?.activeFilters?.size > 0 && !isFavoriteFilterEditMode) {
                            <button-field-pds3 type="text" flowClass="custom-wk-clear-button">
                                <button type="button" class="navbar_clearFilters wk-fm__navbar-filter-btn--padding" (click)="clearAllFilters()">
                                    <icon-pds3 name="wk-icon-filled-close"></icon-pds3>
                                    <span>{{ "FiltersSidebar.Labels.ClearAllFilters" | translate }}</span>
                                </button>
                            </button-field-pds3>
                        }

                        @if (this.filtersService?.activeFilters?.size === 0) {
                            <label class="wk-fm__navbar-filter-no-active-filters">{{ "FiltersSidebar.Labels.NoActiveFilters" | translate }}</label>
                        }

                        <div [attr.class]="'pill-story7'">
                            <div [attr.class]="'pill-group-container'">
                                <pill-group-pds3
                                    cg3-theme="PDS-v3"
                                    (visiblePillsChange)="onVisiblePillsChange($event)"
                                    groupId="pill-group-active-filters"
                                    [srLabelledBy]="headingId"
                                    [initLinesCount]="linesCount"
                                    [isExpanded]="isExpanded"
                                >
                                    <sr-only-pds3 flowClass="pill-group-heading-sr" *headingPds3>
                                        <h3 [attr.id]="headingId" flow-id="pill-group-heading">Active filters</h3>
                                    </sr-only-pds3>

                                    <!-- Alerts Pills -->
                                    @if (alertsFilterModel?.selection?.length) {
                                        @for (sel of alertsFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(alertsFilterModel, sel, onAlertsChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ alertsFilterModel.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Priority Pills -->
                                    @if (priorityFilterModel?.selection?.length) {
                                        @for (sel of priorityFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(priorityFilterModel, sel, onPriorityChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ priorityFilterModel.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Job Type Pills -->
                                    @if (jobsTypeFilterModel?.selection?.length) {
                                        @for (sel of jobsTypeFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(jobsTypeFilterModel, sel, onJobsTypeChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ "FiltersSidebar.Labels.JobType" | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Jobs Group1 Pills -->
                                    @if (jobsGroup1FilterModel?.selection?.length) {
                                        @for (sel of jobsGroup1FilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(jobsGroup1FilterModel, sel, onJobsGroup1Changed)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3>
                                                    @if (currentLanguage === "en-CA") {
                                                        {{ "FiltersSidebar.Labels.Job" | wkTranslate }}
                                                        {{ jobsGroup1FilterModel.label | wkTranslate }} - {{ sel.text | wkTranslate }}
                                                    } @else {
                                                        {{ jobsGroup1FilterModel.label | wkTranslate }}
                                                        {{ "FiltersSidebar.Labels.Job" | wkTranslate }} - {{ sel.text | wkTranslate }}
                                                    }
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Jobs Group2 Pills -->
                                    @if (jobsGroup2FilterModel?.selection?.length) {
                                        @for (sel of jobsGroup2FilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(jobsGroup2FilterModel, sel, onJobsGroup2Changed)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3>
                                                    @if (currentLanguage === "en-CA") {
                                                        {{ "FiltersSidebar.Labels.Job" | wkTranslate }}
                                                        {{ jobsGroup2FilterModel.label | wkTranslate }} - {{ sel.text | wkTranslate }}
                                                    } @else {
                                                        {{ jobsGroup2FilterModel.label | wkTranslate }}
                                                        {{ "FiltersSidebar.Labels.Job" | wkTranslate }} - {{ sel.text | wkTranslate }}
                                                    }
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Group 1 Pills -->
                                    @if (group1FilterModel?.selection?.length) {
                                        @for (sel of group1FilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(group1FilterModel, sel, onGroup1Changed)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3>
                                                    {{
                                                        "FiltersSidebar.Labels.ContactGroupPillLabel"
                                                            | translate: { label: (group1FilterModel?.label | wkTranslate) }
                                                    }}
                                                    -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Group 2 Pills -->
                                    @if (group2FilterModel?.selection?.length) {
                                        @for (sel of group2FilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(group2FilterModel, sel, onGroup2Changed)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3>
                                                    {{
                                                        "FiltersSidebar.Labels.ContactGroupPillLabel"
                                                            | translate: { label: (group2FilterModel?.label | wkTranslate) }
                                                    }}
                                                    -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Assignees Pills -->
                                    @for (model of this.assigneesFilterGeneratorService.models(); track model.id) {
                                        @for (sel of model.selection; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(model, sel, onAssigneeChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3>
                                                    {{
                                                        "FiltersSidebar.Labels.ContactAssigneePillLabel"
                                                            | translate: { label: (model.label | wkTranslate) }
                                                    }}
                                                    -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Target Start Date Pill -->
                                    @if (
                                        targetStartFilterModel?.selection?.value === "none" ||
                                        (targetStartFilterModel?.selection?.value === "dueOn" && targetStartDueOnFilterModel?.date) ||
                                        (targetStartFilterModel?.selection?.value === "dateRange" &&
                                            (targetStartFromFilterModel?.date || targetStartToFilterModel?.date))
                                    ) {
                                        <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                            <button (click)="onTargetStartChanged('all')" type="button">
                                                <sr-only-pds3>Remove</sr-only-pds3>{{ "FiltersSidebar.Labels.TargetStartPill" | translate }} -
                                                @switch (targetStartFilterModel.selection.value) {
                                                    @case ("none") {
                                                        {{ "FiltersSidebar.Options.Dates.None" | translate }}
                                                    }
                                                    @case ("dueOn") {
                                                        {{ targetStartDueOnFilterModel.date | date: datePillFormat }}
                                                    }
                                                    @case ("dateRange") {
                                                        ({{
                                                            targetStartFromFilterModel?.date
                                                                ? (targetStartFromFilterModel.date | date: datePillFormat)
                                                                : ("FiltersSidebar.Labels.DateNotApplicable" | translate)
                                                        }}
                                                        -
                                                        {{
                                                            targetStartToFilterModel?.date
                                                                ? (targetStartToFilterModel.date | date: datePillFormat)
                                                                : ("FiltersSidebar.Labels.DateNotApplicable" | translate)
                                                        }})
                                                    }
                                                }
                                                <icon-pds3 name="wk-icon-filled-close" />
                                            </button>
                                        </pill-dismissible-field-pds3>
                                    }

                                    <!-- Target End Date Pill -->
                                    @if (
                                        targetEndFilterModel?.selection?.value === "none" ||
                                        (targetEndFilterModel?.selection?.value === "dueOn" && targetEndDueOnFilterModel?.date) ||
                                        (targetEndFilterModel?.selection?.value === "dateRange" &&
                                            (targetEndFromFilterModel?.date || targetEndToFilterModel?.date))
                                    ) {
                                        <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                            <button (click)="onTargetEndChanged('all')" type="button">
                                                <sr-only-pds3>Remove</sr-only-pds3>{{ "FiltersSidebar.Labels.TargetEndPill" | translate }} -
                                                @switch (targetEndFilterModel.selection.value) {
                                                    @case ("none") {
                                                        {{ "FiltersSidebar.Options.Dates.None" | translate }}
                                                    }
                                                    @case ("dueOn") {
                                                        {{ targetEndDueOnFilterModel.date | date: datePillFormat }}
                                                    }
                                                    @case ("dateRange") {
                                                        ({{
                                                            targetEndFromFilterModel?.date
                                                                ? (targetEndFromFilterModel.date | date: datePillFormat)
                                                                : ("FiltersSidebar.Labels.DateNotApplicable" | translate)
                                                        }}
                                                        -
                                                        {{
                                                            targetEndToFilterModel?.date
                                                                ? (targetEndToFilterModel.date | date: datePillFormat)
                                                                : ("FiltersSidebar.Labels.DateNotApplicable" | translate)
                                                        }})
                                                    }
                                                }
                                                <icon-pds3 name="wk-icon-filled-close" />
                                            </button>
                                        </pill-dismissible-field-pds3>
                                    }

                                    <!-- Period Ended Pill -->
                                    @if (
                                        periodEndFilterModel?.selection?.value === "none" ||
                                        (periodEndFilterModel?.selection?.value === "dueOn" && periodEndDueOnFilterModel?.date) ||
                                        (periodEndFilterModel?.selection?.value === "dateRange" &&
                                            (periodEndFromFilterModel?.date || periodEndToFilterModel?.date))
                                    ) {
                                        <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                            <button (click)="onPeriodEndChanged('all')" type="button">
                                                <sr-only-pds3>Remove</sr-only-pds3>{{ "FiltersSidebar.Labels.PeriodEndPill" | translate }} -
                                                @switch (periodEndFilterModel.selection.value) {
                                                    @case ("none") {
                                                        {{ "FiltersSidebar.Options.Dates.None" | translate }}
                                                    }
                                                    @case ("dueOn") {
                                                        {{ periodEndDueOnFilterModel.date | date: datePillFormat }}
                                                    }
                                                    @case ("dateRange") {
                                                        ({{
                                                            periodEndFromFilterModel?.date
                                                                ? (periodEndFromFilterModel.date | date: datePillFormat)
                                                                : ("FiltersSidebar.Labels.DateNotApplicable" | translate)
                                                        }}
                                                        -
                                                        {{
                                                            periodEndToFilterModel?.date
                                                                ? (periodEndToFilterModel.date | date: datePillFormat)
                                                                : ("FiltersSidebar.Labels.DateNotApplicable" | translate)
                                                        }})
                                                    }
                                                }
                                                <icon-pds3 name="wk-icon-filled-close" />
                                            </button>
                                        </pill-dismissible-field-pds3>
                                    }

                                    <!-- Users Pills -->
                                    @if (usersFilterModel?.selection?.length) {
                                        @for (sel of usersFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(usersFilterModel, sel, onUsersChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ "FiltersSidebar.Labels.Users" | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Currently Responsible Pills -->
                                    @if (currentlyResponsibleFilterModel?.selection?.length) {
                                        @for (sel of currentlyResponsibleFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button
                                                    (click)="onPillClose(currentlyResponsibleFilterModel, sel, onCurrentlyResponsibleChanged)"
                                                    type="button"
                                                >
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ currentlyResponsibleFilterModel.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Job partner Pills -->
                                    @if (jobPartnerFilterModel?.selection?.length) {
                                        @for (sel of jobPartnerFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(jobPartnerFilterModel, sel, onJobPartnerChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3>{{ jobPartnerFilterModel.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Job manager Pills -->
                                    @if (jobManagerFilterModel?.selection?.length) {
                                        @for (sel of jobManagerFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(jobManagerFilterModel, sel, onJobManagerChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3>{{ jobManagerFilterModel.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Job owner Pills -->
                                    @if (jobOwnerFilterModel?.selection?.length) {
                                        @for (sel of jobOwnerFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(jobOwnerFilterModel, sel, onJobOwnerChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3>{{ jobOwnerFilterModel.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <pill-suggestion-field-pds3 *pillMoreButtonPds3 size="small">
                                        @if (morePillsCount > 0) {
                                            <button
                                                (click)="onExpandButtonToggle()"
                                                type="button"
                                                flow-id="pill-group-more-button"
                                                aria-controls="pill-group-active-filters"
                                                [attr.aria-expanded]="this.isExpanded"
                                            >
                                                @if (isExpanded) {
                                                    {{ "FiltersSidebar.Actions.ShowLess" | translate }}
                                                }
                                                @if (!isExpanded) {
                                                    {{ "+" + morePillsCount + " " + ("FiltersSidebar.Actions.ShowMore" | translate) }}
                                                }
                                            </button>
                                        }
                                    </pill-suggestion-field-pds3>
                                </pill-group-pds3>
                            </div>
                        </div>
                        <div cg3-theme="PDS-v3" id="saved-filters" class="wk-fm__saved-filters">
                            @if (currentFavoriteFilter?.id !== "assigned-to-me" && isFavoriteFilterEditMode) {
                                <button-field-pds3 type="text" size="small">
                                    <button type="button" (click)="enableFavoriteFilterEditMode(false)" class="wk-fm__save-filter-btn--color">
                                        <icon-pds3 name="wk-icon-close"></icon-pds3>
                                        <span>{{ "Actions.Cancel" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }
                            @if (
                                currentFavoriteFilter?.id !== "assigned-to-me" &&
                                favoritesFilters.length > 1 &&
                                currentFavoriteFilter.id.length > 0 &&
                                !isFavoriteFilterEditMode
                            ) {
                                <button-field-pds3 type="text" size="small" flowClass="custom-wk-delete-button" color="danger">
                                    <button type="button" (click)="openModal('delete')">
                                        <icon-pds3 name="wk-icon-trash"></icon-pds3>
                                        <span>{{ "Actions.Delete" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }
                            @if (currentFavoriteFilter?.id !== "assigned-to-me" && currentFavoriteFilter.id.length > 0 && !isFavoriteFilterEditMode) {
                                <button-field-pds3 type="text" size="small">
                                    <button type="button" class="wk-fm__save-filter-btn--border" (click)="enableFavoriteFilterEditMode(true)">
                                        <icon-pds3 name="wk-icon-pencil"></icon-pds3>
                                        <span>{{ "Actions.Edit" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }
                            @if (currentFavoriteFilter?.id !== "assigned-to-me" && isFavoriteFilterEditMode) {
                                <button-field-pds3 type="text" size="small">
                                    <button type="button" flow-id="text-button" (click)="openModal('rename')">
                                        <icon-pds3 name="wk-icon-pencil"></icon-pds3>
                                        <span>{{ "Actions.Rename" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }

                            @if (
                                (!currentFavoriteFilter.id &&
                                    currentFavoriteFilter?.id !== "assigned-to-me" &&
                                    filtersService?.activeFilters?.size > 0) ||
                                (currentFavoriteFilter?.id !== "assigned-to-me" && isFavoriteFilterEditMode)
                            ) {
                                <button-field-pds3 type="text" size="small">
                                    <button
                                        type="button"
                                        class="wk-fm__save-filter-btn--border"
                                        (click)="
                                            modalActionType = 'save';
                                            currentFavoriteFilter.id.length > 0 ? saveFavoritesFilter(currentFavoriteFilter.name) : openModal('save')
                                        "
                                    >
                                        <icon-pds3 name="wk-icon-save"></icon-pds3>
                                        <span>{{ "Actions.Save" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }
                        </div>
                    </div>
                </accordion-item-pds3>
                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_General']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_General')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>
                        {{ "FiltersSidebar.Labels.General" | translate }}
                    </accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (alertsFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ alertsFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="alerts"
                                [data]="alertsFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="alertsFilterModel.selection"
                                (ngModelChange)="onAlertsChanged($event, true)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            />
                        }
                        @if (priorityFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ priorityFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="priority"
                                [data]="priorityFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="priorityFilterModel.selection"
                                (ngModelChange)="onPriorityChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            />
                        }
                    </div>
                </accordion-item-pds3>

                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_Jobs']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_Jobs')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>
                        {{ "JobsAndBilling.JobFilters" | translate }}
                    </accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (jobsTypeFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ jobsTypeFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="jobsType"
                                [data]="filteredJobsTypeOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="jobsTypeFilterModel.selection"
                                (ngModelChange)="onJobsTypeChanged($event)"
                                (filterChange)="onFilterChange($event, 'jobsType')"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            />
                        }
                        @if (jobsGroup1FilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ jobsGroup1FilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="jobsGroup1"
                                [data]="filteredGroup1Options"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="jobsGroup1FilterModel.selection"
                                (ngModelChange)="onJobsGroup1Changed($event)"
                                (filterChange)="onFilterChange($event, 'jobsGroup1')"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            />
                        }
                        @if (jobsGroup2FilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ jobsGroup2FilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="jobsGroup2"
                                [data]="filteredGroup2Options"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="jobsGroup2FilterModel.selection"
                                (ngModelChange)="onJobsGroup2Changed($event)"
                                (filterChange)="onFilterChange($event, 'jobsGroup2')"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            />
                        }
                    </div>
                </accordion-item-pds3>

                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_ContactDetails']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_ContactDetails')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>
                        {{ "FiltersSidebar.Labels.ContactDetails" | translate }}
                    </accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (group1FilterModel && isGroup1Enabled) {
                            <label class="wk-fm__sidebar-filter-label">{{ group1FilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="group1"
                                id="group1"
                                [data]="group1FilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="group1FilterModel.selection"
                                (ngModelChange)="onGroup1Changed($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            />
                        }
                        @if (group2FilterModel && isGroup2Enabled) {
                            <label class="wk-fm__sidebar-filter-label">{{ group2FilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="group2"
                                id="group2"
                                [data]="group2FilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="group2FilterModel.selection"
                                (ngModelChange)="onGroup2Changed($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            />
                        }
                        @if (this.assigneesFilterGeneratorService.models().length) {
                            @for (model of this.assigneesFilterGeneratorService.models(); track model.id) {
                                <label class="wk-fm__sidebar-filter-label">{{ model.label | wkTranslate }}</label>

                                <kendo-multiselect-wrapper
                                    name="assignees_{{ $index }}"
                                    id="assignees_{{ $index }}"
                                    [data]="model.applicableOptions"
                                    textField="text"
                                    valueField="value"
                                    [(ngModel)]="model.selection"
                                    (ngModelChange)="onAssigneeChanged(model)"
                                    [valuePrimitive]="false"
                                    placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                    noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                    clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                    [virtual]="true"
                                />
                            }
                        }
                    </div>
                </accordion-item-pds3>

                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_Dates']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_Dates')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>
                        {{ "FiltersSidebar.Labels.Dates.Label" | translate }}
                    </accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (targetStartFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ targetStartFilterModel.label | wkTranslate }}</label>
                            <kendo-dropdownlist-wrapper
                                [data]="targetStartFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [ngModel]="targetStartFilterModel.selection?.value"
                                (ngModelChange)="onTargetStartChanged($event)"
                            />
                            <wk-fm-target-start-dates
                                [selection]="targetStartFilterModel.selection"
                                [dueOnModel]="targetStartDueOnFilterModel"
                                [fromModel]="targetStartFromFilterModel"
                                [toModel]="targetStartToFilterModel"
                                (dueOnChange)="onTargetStartDueOnChanged($any($event))"
                                (fromChange)="onTargetStartFromChanged($any($event))"
                                (toChange)="onTargetStartToChanged($any($event))"
                            />
                        }
                        @if (targetEndFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ targetEndFilterModel.label | wkTranslate }}</label>
                            <kendo-dropdownlist-wrapper
                                [data]="targetEndFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [ngModel]="targetEndFilterModel.selection?.value"
                                (ngModelChange)="onTargetEndChanged($event)"
                            />
                            <wk-fm-target-end-dates
                                [selection]="targetEndFilterModel.selection"
                                [dueOnModel]="targetEndDueOnFilterModel"
                                [fromModel]="targetEndFromFilterModel"
                                [toModel]="targetEndToFilterModel"
                                (dueOnChange)="onTargetEndDueOnChanged($any($event))"
                                (fromChange)="onTargetEndFromChanged($any($event))"
                                (toChange)="onTargetEndToChanged($any($event))"
                            />
                        }
                        @if (periodEndFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ periodEndFilterModel.label | wkTranslate }}</label>
                            <kendo-dropdownlist-wrapper
                                [data]="periodEndFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [ngModel]="periodEndFilterModel.selection?.value"
                                (ngModelChange)="onPeriodEndChanged($event)"
                            />
                            <wk-fm-period-end-dates
                                [selection]="periodEndFilterModel.selection"
                                [dueOnModel]="periodEndDueOnFilterModel"
                                [fromModel]="periodEndFromFilterModel"
                                [toModel]="periodEndToFilterModel"
                                (dueOnChange)="onPeriodEndDueOnChanged($any($event))"
                                (fromChange)="onPeriodEndFromChanged($any($event))"
                                (toChange)="onPeriodEndToChanged($any($event))"
                            />
                        }
                    </div>
                </accordion-item-pds3>

                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_JobsAssignees']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_JobsAssignees')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>
                        {{ "FiltersSidebar.Labels.Assignees" | translate }}
                    </accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (usersFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ "FiltersSidebar.Labels.Users" | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="users"
                                [data]="usersFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="usersFilterModel.selection"
                                (ngModelChange)="onUsersChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                [virtual]="true"
                            />
                        }
                        <h6 class="wk-fm__sidebar-filter-search-by-roles">{{ "JobsAndBilling.SearchByRoles" | wkTranslate }}</h6>
                        @if (currentlyResponsibleFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ currentlyResponsibleFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="currentlyResponsible"
                                [data]="currentlyResponsibleFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="currentlyResponsibleFilterModel.selection"
                                (ngModelChange)="onCurrentlyResponsibleChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                [virtual]="true"
                            />
                        }
                        @if (jobPartnerFilterModel && jobsAndBillingCurrentSettings?.jobPartnerEnabled) {
                            <label class="wk-fm__sidebar-filter-label">{{ jobPartnerFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="jobPartner"
                                [data]="jobPartnerFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="jobPartnerFilterModel.selection"
                                (ngModelChange)="onJobPartnerChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                [virtual]="true"
                            />
                        }
                        @if (jobManagerFilterModel && jobsAndBillingCurrentSettings?.jobManagerEnabled) {
                            <label class="wk-fm__sidebar-filter-label">{{ jobManagerFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="jobManager"
                                [data]="jobManagerFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="jobManagerFilterModel.selection"
                                (ngModelChange)="onJobManagerChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                [virtual]="true"
                            />
                        }
                        @if (jobOwnerFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ jobOwnerFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="jobOwner"
                                [data]="jobOwnerFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="jobOwnerFilterModel.selection"
                                (ngModelChange)="onJobOwnerChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                [virtual]="true"
                            />
                        }
                    </div>
                </accordion-item-pds3>
            </accordion-pds3>
        </vertical-layout-content-pds3>
    </vertical-layout-pds3>
</side-modal-pds3>

<!-- dialogue modals -->
<ng-template #saveFilterDialogue>
    <div class="modal-header info">
        <h3 class="modal-title pull-left">
            {{
                modalActionType === "rename"
                    ? ("FiltersSidebar.Events.RenameFilterTitle" | wkTranslate)
                    : ("FiltersSidebar.Events.SaveFilterTitle" | wkTranslate)
            }}
        </h3>

        <icon-pds3 name="wk-icon-filled-close" (click)="bsModalRef.hide()" flowClass="custom-close-icon"></icon-pds3>
    </div>
    <div cg3-theme="PDS-v3" class="wk-modal-body">
        <form>
            <div class="form-group">
                <div class="wk-modal-input-container">
                    <label class="wk-modal-input-container--label">{{ "General.Name" | translate }}</label>
                    <text-field-pds3 flowClass="custom-text-field">
                        <input
                            type="text"
                            id="filterNameInput"
                            name="name"
                            required
                            [(ngModel)]="currentFavoriteFilter.name"
                            maxlength="50"
                            autocomplete="off"
                            #filterNameInput
                        />
                    </text-field-pds3>
                </div>
            </div>
            <div class="wk-modal-button-div">
                <button-field-pds3 type="primary" size="large" flowClass="custom-button primary">
                    <button
                        type="button"
                        [attr.aria-disabled]="currentFavoriteFilter.name.trim().length === 0"
                        [disabled]="currentFavoriteFilter.name.trim().length === 0"
                        (click)="saveFavoritesFilter(currentFavoriteFilter.name)"
                    >
                        {{ "Settings.Save" | translate }}
                    </button>
                </button-field-pds3>
                <button-field-pds3 type="secondary" size="large" flowClass="custom-button secondary">
                    <button type="button" flow-id="secondary-button" (click)="bsModalRef.hide()">{{ "Settings.btnCancel" | translate }}</button>
                </button-field-pds3>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #deleteFilterDialogue>
    <div class="modal-header danger">
        <h3 class="modal-title pull-left">{{ "FiltersSidebar.Events.DeleteFilterTitle" | wkTranslate }}</h3>

        <icon-pds3 name="wk-icon-filled-close" (click)="bsModalRef.hide()" flowClass="custom-close-icon"></icon-pds3>
    </div>
    <div class="wk-modal-body delete-dialog">
        <div>
            <div class="wk-modal-body delete-dialog-content">{{ "FiltersSidebar.Events.DeleteConfirmationMessage" | wkTranslate }}</div>
            <ul>
                <li>
                    {{ currentFavoriteFilter?.name }}
                </li>
            </ul>
        </div>

        <div cg3-theme="PDS-v3" class="wk-modal-button-div">
            <button-field-pds3 type="primary" size="large" flowClass="custom-button danger">
                <button type="button" (click)="deleteFavoriteFilter(currentFavoriteFilter?.id)">{{ "General.Delete" | wkTranslate }}</button>
            </button-field-pds3>
            <button-field-pds3 type="secondary" size="large" flowClass="custom-button secondary">
                <button type="button" flow-id="secondary-button" (click)="bsModalRef.hide()">{{ "Settings.btnCancel" | translate }}</button>
            </button-field-pds3>
        </div>
    </div>
</ng-template>
